<template>
  <div v-show="isActive">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'DTab',
  
  inject: ['tabs', 'activeTab', 'addTab', 'removeTab'],
  
  props: {
    title: {
      type: String,
      required: true
    }
  },
  
  data() {
    return {
      index: null
    };
  },
  
  computed: {
    isActive() {
      return this.index === this.activeTab;
    }
  },
  
  created() {
    this.addTab({
      title: this.title
    });
    this.index = this.tabs.length - 1;
  },
  
  beforeUnmount() {
    this.removeTab(this.index);
  }
};
</script>